import React, { useState, useEffect } from 'react';
import LogoGif from '../../assets/img/logo.gif';
import './CustomLoading.scss';

const STEPS = [
  { label: 'Solicitando turno',          icon: '📋' },
  { label: 'Validando datos',            icon: '🔍' },
  { label: 'Verificando disponibilidad', icon: '📅' },
  { label: 'Confirmando reserva',        icon: '✅' },
];

const CustomLoading = ({ loading }) => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    if (!loading) {
      setActiveStep(0);
      return;
    }
    const interval = setInterval(() => {
      setActiveStep((prev) => (prev < STEPS.length - 1 ? prev + 1 : 0));
    }, 1400);
    return () => clearInterval(interval);
  }, [loading]);

  if (!loading) return null;

  return (
    <div className="cl-wrapper">
      {/* Isotipo con anillos pulsantes */}
      <div className="cl-pulse-ring">
        <div className="cl-pulse-ring__inner">
          <img src={LogoGif} alt="Cargando" className="cl-logo" />
        </div>
      </div>

      {/* Texto animado del paso actual */}
      <div className="cl-step-label" key={activeStep}>
        <span className="cl-step-label__icon">{STEPS[activeStep].icon}</span>
        <span className="cl-step-label__text">{STEPS[activeStep].label}...</span>
      </div>

      <p className="cl-hint">No cerrés esta pantalla</p>

      {/* Barra de progreso */}
      <div className="cl-steps-track">
        {STEPS.map((_, i) => (
          <div
            key={i}
            className={`cl-step-dot ${i < activeStep ? 'done' : ''} ${i === activeStep ? 'active' : ''}`}
          />
        ))}
      </div>
    </div>
  );
};

export default CustomLoading;
